import { formatCpDate } from '@cp-shared-19/common-utilities';
import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const openVerificationValidationSchema = (t: TFunction): Yup.ObjectSchema => {
    return Yup.object().shape({
        contractNumber: Yup.string().required(t('form.validation.contract-number-required')),
        licensePlate: Yup.string().required(t('form.validation.license-plate-required')),
        initials: Yup.string()
            .required(t('form.validation.initials.required'))
            .matches(/^[a-zÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß.]*$/i, t('form.validation.initials.invalidCharacters'))
            .min(1, t('form.validation.initials.minLength', { value: 1 }))
            .max(20, t('form.validation.initials.maxLength', { value: 20 })),
        lastName: Yup.string()
            .required(t('form.validation.lastName.required'))
            .matches(
                /^[\sa-zÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß.'-]*$/i,
                t('form.validation.lastName.invalidCharacters'),
            )
            .min(2, t('form.validation.lastName.minLength', { value: 2 }))
            .max(35, t('form.validation.lastName.maxLength', { value: 35 })),
        birthday: Yup.string()
            .required(t('form.validation.birthday-required'))
            .test('format', t('form.validation.birthday-invalid-format'), (date) =>
                formatCpDate(date, 'DD.MM.YYYY').isValid(),
            ),
    });
};
